<!-- Result Grid -->
<div [hidden]="waiting" class="row">
  <div class="col-center">
    <div align="center" [hidden]="!loading" id="loadingsymbol">
      <i class="fa fa-circle-notch fa-spin fa-3x fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </div>

    <table [hidden]="loading" class="table table-hover">
      <thead>
        <tr>
          <!-- Status Column Header -->
          <th>Status</th>

          <th>Booking Type</th>

          @if (isAdmin && showOrderInfoColumn) {
            <th>Order Info</th>
          }

          <th>Renter Name</th>

          <!-- Start Date Column Header -->
          @if (!sortEnabled) {
            <th>Start Date</th>
          }
          @if (sortEnabled) {
            <th (click)="setSortCol('startDate')" style="cursor: pointer" class="sortable-header">
              Start Date
              <sort-indicator [columnName]="'startDate'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>
          }

          <!-- End  Date Column Header -->
          @if (!sortEnabled) {
            <th>End Date</th>
          }
          @if (sortEnabled) {
            <th (click)="setSortCol('endDate')" style="cursor: pointer" class="sortable-header">
              End Date
              <sort-indicator [columnName]="'endDate'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>
          }
          <th>Total People</th>

          @if (showAmount) {
            <th>Amount</th>
          }

          <!-- Renter Email/Phone Column Header -->
          @if (showRenterContactInfo) {
            @if (!sortEnabled) {
              <th>Renter Email/Phone</th>
            }
            @if (sortEnabled) {
              <th (click)="setSortCol('renterEmailAddress')" style="cursor: pointer" class="sortable-header">
                Renter Email/Phone
                <sort-indicator [columnName]="'renterEmailAddress'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
              </th>
            }
          }

          @if (isAdmin) {
            <!-- Reservation ID Column Header -->
            @if (!sortEnabled) {
              <th>Reservation ID</th>
            }
            @if (sortEnabled) {
              <th (click)="setSortCol('reservationId')" style="cursor: pointer" class="sortable-header">
                Reservation ID
                <sort-indicator [columnName]="'reservationId'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
              </th>
            }
            <th>Seasonal ID</th>
            <th>Seasonal Lease ID</th>
            <th>Permit ID</th>
          }

          <!-- <th (click)="setSortCol('startDate')" style="cursor: pointer;">Start Date</th> -->
        </tr>
      </thead>
      <tbody>
        @for (item of bookings; track item) {
          <tr class="reservation-row past-row">
            <td>
              @if (isUpcoming(item)) {
                <span class="label label-info">Upcoming</span>
              }
              @if (isPast(item)) {
                <span class="label label-warning">Past</span>
              }
              @if (isToday(item)) {
                <span class="label label-default">Today</span>
              }
              @if (item?.canceled) {
                <span class="label label-danger">Canceled</span>
              }
            </td>
            <td>{{ item.bookingType }}</td>
            @if (isAdmin && showOrderInfoColumn) {
              <td>
                @if (isAdmin) {
                  <span class="link" (click)="onReservationClick(item)" title="Click to view reservation">{{
                    item.financialAbbreviation
                  }}</span>
                }
                @if (!isAdmin) {
                  <span>{{ item.financialAbbreviation }}</span>
                }
              </td>
            }
            <td>{{ item.fullName }}</td>
            <td>{{ item.startDate | date }}</td>
            <td>{{ item.endDate | date }}</td>
            <td>{{ item.totalPeople }}</td>
            <!-- <td>{{ item.totalAmount  | currency:'USD' : 'symbol' : '1.0-0'}}</td> -->
            @if (showAmount) {
              <td>{{ item.landownerAmount | currency: "USD":"symbol":"1.0-0" }}</td>
            }
            @if (showRenterContactInfo) {
              <td>
                @if (isAdmin) {
                  <span class="link" (click)="onRenterEmailAddressClick(item)" title="Click to renter's account">{{
                    item.renterEmailAddress
                  }}</span>
                }
                @if (item.renterEmailAddress && !isAdmin) {
                  <a href="mailto:{{ item.renterEmailAddress }}">{{ item.renterEmailAddress }} </a>
                }
                <div>
                  {{ item.renterPhone | phoneNumber }}
                </div>
              </td>
            }
            @if (isAdmin) {
              <td>
                @if (isAdmin) {
                  <a class="link" (click)="onReservationClick(item); $event.preventDefault()" title="Click to view reservation" href="javascript:void(0)">{{
                    item.reservationId
                  }}</a>
                }
                @if (!isAdmin) {
                  <span>{{ item.reservationId }}</span>
                }
                @if (isAdmin) {
                  <link-to-booking-detail [bookingId]="item.bookingId"> </link-to-booking-detail>
                }
              </td>
              <td></td>
              <td>{{ item.seasonalRentalId }}</td>
              <td>{{ item.permitId }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (isAdmin && displayNotes) {
    <div class="note-container">
      <p>
        <span style="font-weight: 800">Order Info Abbreviations:</span> R: Reservation, SF: Service Fee, BF: Base Fee, C: Credit, E: Extended
        Discount
      </p>
      <div>
        Example #1: R:35,SF:5,BF:4 is:
        <div>
          <ul>
            <li>$35.00 Reservation</li>
            <li>$5.00 Service Fee</li>
            <li>$4.00 Base Fee</li>
          </ul>
        </div>
      </div>
      <div>
        Example #2: R:105,SF:15,BF:4,C:-10 is:
        <div>
          <ul>
            <li>$105.00 Reservation</li>
            <li>$15.00 Service Fee</li>
            <li>$4.00 Base Fee</li>
            <li>$10.00 Credit</li>
          </ul>
        </div>
      </div>
    </div>
  }
</div>
